"use strict";
function isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
exports.isDate = isDate;
//# sourceMappingURL=isDate.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/rxjs/util/isDate.js
 ** module id = 680
 ** module chunks = 0
 **/